import * as XLSX from 'xlsx';
import { message } from 'antd';

export const optimizeAlgorithmExport = (bbsAlgorithmResult,bbsId) => {
  if (!bbsAlgorithmResult || bbsAlgorithmResult?.length === 0) {
    console.error('No data available to export.');
    message.error('Error: No data available to export.');
    return;
  }

  // Remove duplicate diameters
  const uniqueData = Array?.from(
    new Map(
      bbsAlgorithmResult?.map((item) => [item?.diameter, item]),
    )?.values(),
  );

  // Sort uniqueData by diameter in ascending order
  uniqueData?.sort((a, b) => a?.diameter - b?.diameter);

  const workbook = XLSX.utils.book_new();

  uniqueData?.forEach((entry) => {
    const { diameter, response } = entry;
    const patterns = response?.patterns?.map((pattern) => ({
      'Pattern No': pattern?.pattern,
      Repetition: pattern?.repetition,
      Offcut: pattern?.waste?.toFixed(2),
      'Offcut percent': pattern?.waste_percentage?.toFixed(2),
      'Cutting pattern from 1 full length': `[${pattern?.cutting_pattern?.join(', ')}]`,
    }));

    const worksheet = XLSX?.utils?.json_to_sheet(patterns);
    XLSX?.utils?.book_append_sheet(workbook, worksheet, `Diameter_${diameter}`);
  });

  XLSX.writeFile(workbook, `${bbsId}_Raw Optimized Data.xlsx`);
};
